import { render, staticRenderFns } from "./nav-header.vue?vue&type=template&id=86ca8a34&scoped=true"
import script from "./nav-header.vue?vue&type=script&lang=js"
export * from "./nav-header.vue?vue&type=script&lang=js"
import style0 from "./nav-header.vue?vue&type=style&index=0&id=86ca8a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ca8a34",
  null
  
)

export default component.exports